<template>
    <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-x-10 gap-y-28 lg:gap-y-16 mx-auto w-3/5 mt-20 md:mt-5">
        <ComponentSkill
            v-for="(skill, index) in skills" 
            :key="index" 
            :skillName="skill.name"
            :skillIllLink="skill.IllLink"
        />
    </div>
</template>

<script>
import ComponentSkill from './ComponentSkill.vue'

export default {
    components: {
        ComponentSkill
    },
    name: 'ComponentContenerSkill',
    data() {
    return {
      skills: [
        { name: 'Java',IllLink:'./img/skills/java-480.png' },
        { name: 'Python',IllLink:'./img/skills/python-480.png' },
        { name: 'Vue',IllLink:'./img/skills/vue-480.png' },
        { name: 'HTML',IllLink:'./img/skills/html-480.png' },
        { name: 'CSS',IllLink:'./img/skills/css-500.png' },
        { name: 'SQL',IllLink:'./img/skills/sql-512.png' },
        { name: 'PHP',IllLink:'./img/skills/php-512.png' },
        { name: 'Symfony',IllLink:'./img/skills/symfony-512.png' },
        { name: 'JavaScript',IllLink:'./img/skills/js-240.png' },
        { name: 'Git',IllLink:'./img/skills/git-480.png'}
      ],
        }
    }
}

</script>
